import * as React from "react";
const SvgFiRrFaceWoozy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-woozy_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10M5.371 9.929a1.002 1.002 0 0 1-.742-1.857c1.213-.484 2.777-1.484 3.539-2.626a1 1 0 1 1 1.664 1.11C8.765 8.157 6.827 9.348 5.371 9.93zM14 10c0-1.657.672-3 1.5-3S17 8.343 17 10s-.672 3-1.5 3-1.5-1.343-1.5-3m-7.447 1.105 4-2a1 1 0 0 1 .895 1.789l-4 2a1 1 0 0 1-.895-1.789m12.284 5.442C18.673 16.798 17.171 19 15 19c-1.161 0-2.03-.768-2.729-1.386-.26-.229-.652-.577-.81-.618-.15.003-.339.124-.657.335-.423.282-1.002.668-1.805.668-1.423 0-2.592-1.173-2.721-1.307a1 1 0 0 1 1.438-1.39c.223.227.829.696 1.282.696.188 0 .377-.12.695-.332.423-.282 1.002-.668 1.805-.668.834 0 1.476.567 2.096 1.116.469.415 1 .884 1.404.884.956 0 1.949-1.22 2.163-1.547.302-.462.922-.59 1.384-.29a1 1 0 0 1 .29 1.384z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-woozy_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceWoozy;
